import { IComponentOptions } from "angular";
import { ProjectDetailMachineComponentController } from "./controller";

export const vsComponentName = "projectDetailMachineComponent";

export const projectDetailMachineComponentOptions: IComponentOptions = {
  controller: ProjectDetailMachineComponentController,
  controllerAs: "projectMachineController",
  template: require("!html-loader!./index.html").default,
  bindings: {
    defaultQuery: "<",
    projectCostDetail: "<",
    
  },
};
